import { Flex } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { useCustomQueryWithParams } from 'shared/hooks/useCustomQueryWithParams.ts'
import DonationForm from './components/DonationForm'
import Header from './components/Header'
import EmptyUser from './components/EmptyUser'
import { useStreamerConfigContext } from '@/contexts/StreamerConfigContext/StreamerConfigContext'
import Card from '@/shared/components/Card'
import { GET_CRYPTO_CURRENCIES } from '@/pages/Donation/api/constants.ts'
import { currenciesApi } from '@/pages/Donation/api'

export default function Content() {
  const { config, isLoading } = useStreamerConfigContext()
  const { isLoading: isCryptoLoading } = useCustomQueryWithParams(
    [GET_CRYPTO_CURRENCIES],
    currenciesApi.getCryptoCurrencies
  )

  let content

  if (isLoading || isCryptoLoading) {
    content = (
      <Flex justify="center" style={{ minHeight: '200px' }}>
        <LoadingOutlined style={{ color: 'var(--accent-light)' }} />
      </Flex>
    )
  } else if (!config) {
    content = <EmptyUser />
  } else {
    content = <DonationForm />
  }

  return (
    <Card>
      <Flex vertical gap={24}>
        <Header />
        {content}
      </Flex>
    </Card>
  )
}
